<script setup>
  import { computed, nextTick, onMounted, ref, watch } from "vue";
  import CommentComposer from "./CommentComposer.vue";
  import { useReviewCommentsStore } from "@stores/survey/reviewComments";

  const props = defineProps({ target: { type: String, required: true }, label: { type: String, default: null } });
  const MAX_TARGET = 24;
  const shortTarget = computed(() =>
    props.target.length > MAX_TARGET ? `${props.target.slice(0, MAX_TARGET - 1)}…` : props.target,
  );
  const emit = defineEmits(["submit", "focus"]);

  const store = useReviewCommentsStore();
  const composer = ref(null);
  const focus = async () => {
    await nextTick();
    composer.value?.focus();
    emit("focus");
  };
  watch(() => store.composerFocusAt, focus);
  onMounted(focus);
</script>

<template>
  <div class="border-t p-3">
    <p
      v-if="label"
      class="mb-1.5 text-xs font-medium text-primary">
      {{ label }}
    </p>
    <CommentComposer
      ref="composer"
      :placeholder="`Comment on ${shortTarget}`"
      @submit="(body, mentions) => emit('submit', body, mentions)" />
  </div>
</template>
